import React from 'react';
import { styled } from 'linaria/react';
import SectionWrapper from '../../../Layout/SectionWrapper';
import Image from '../components/Image';
import { theme } from '../../../Theme';

const QuoteBlockWrapper = styled(SectionWrapper)`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
`;

const ContentWrapper = styled(SectionWrapper)`
  display: flex;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: center;
  flex-direction: ${({ position }) =>
    position === 'right'
      ? 'row-reverse'
      : position === 'center'
      ? 'column'
      : 'row'};
  align-items: ${({ position }) =>
    position === 'center' ? 'center' : 'flex-start'};
  gap: 34px;

  ${theme.below.md} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const TextContent = styled('div')`
  flex-direction: column;
  text-align: ${({ position }) => (position === 'center' ? 'center' : 'left')};
  max-width: ${({ position }) => (position === 'center' ? '722px' : '486px')};
  position: sticky;
  top: 220px;
  z-index: 1;
  align-items: ${({ position }) =>
    position === 'center' ? 'center' : 'flex-start'};

  ${theme.below.md} {
    position: relative;
    width: 80%;
    top: 0;
    margin-left: 0;
  }
`;

const Title = styled.h1`
  font-family: ${theme.fonts.secondary};
  font-size: calc(2vw + 20px);
  font-weight: 325;
  letter-spacing: -1px;
  line-height: 1.2;

  ${theme.below.md} {
    font-size: calc(3vw + 10px);
    line-height: 1.1;
  }
`;

const Name = styled.div`
  font-size: 14px;
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ImageWrapper = styled.div`
  max-width: 598px;
  width: 100%;
  height: ${({ ratio }) => (ratio === '1:1' ? '100%' : '125%')};
  aspect-ratio: ${({ ratio }) => (ratio === '1:1' ? '1 / 1' : '4 / 5')};
  display: flex;
  z-index: 0;
  margin-bottom: 200px;

  ${theme.below.md} {
    margin-bottom: 0;
  }
`;

const QuoteBlock = ({ title, media, ratio, position, name }) => (
  <QuoteBlockWrapper>
    <ContentWrapper position={position}>
      <TextContent position={position}>
        <Title>{title}</Title>
        <Name>{name}</Name>
      </TextContent>
      <ImageWrapper ratio={ratio}>
        <Image
          fillAvailableSpace
          src={media.filename}
          alt={media.alt || title}
          imageAspect={ratio}
        />
      </ImageWrapper>
    </ContentWrapper>
  </QuoteBlockWrapper>
);

export default QuoteBlock;
